<template>
  <div>
    <logged-in-header />
    <vendings />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import vendings from "../components/vendings/VendingsPanel";

export default {
  components: {
    loggedInHeader,
    vendings
  }
};
</script>
